/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveUserInput
 */
export interface RemoveUserInput {
    /**
     * 
     * @type {string}
     * @memberof RemoveUserInput
     */
    userId?: string;
}

/**
 * Check if a given object implements the RemoveUserInput interface.
 */
export function instanceOfRemoveUserInput(value: object): value is RemoveUserInput {
    return true;
}

export function RemoveUserInputFromJSON(json: any): RemoveUserInput {
    return RemoveUserInputFromJSONTyped(json, false);
}

export function RemoveUserInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveUserInput {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function RemoveUserInputToJSON(json: any): RemoveUserInput {
    return RemoveUserInputToJSONTyped(json, false);
}

export function RemoveUserInputToJSONTyped(value?: RemoveUserInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
    };
}

